import { parse } from '../../util/urlHelpers';
import { createNewListing, getOwnJobRfpListings, getUserDetails, conversations, chatMessages, manualTransactions, sendMeetingScheduledMail, sendPostingInvitation, trackIntegrityCheck, updateTransactionMetadata, updateTransition, fetchPersonaRecords, checkCustomerIntegrityCheckStatus, getAddedUsersOfCompany, getJobApplicationMatchScore, sendSkillFitInvitation, resendSkillFitInvitation, checkCustomerSkillFitCheckStatus, skillFitScoreAndRiskForDashboard, requestIntegrityCheckRecheck } from '../../util/api';
import { createImageVariantConfig } from '../../util/sdkLoader';
import { getAllTransitionsForEveryProcess } from '../../transactions/transaction';
import { storableError } from '../../util/errors';
import socket from '../../util/socket';
import { denormalisedResponseEntities } from '../../util/data';
import { userTypeOf } from '../../util/userType';
import { normalizeScope } from '../../util/integrityCheckScope';
import { teamRoleOf } from '../../util/teamRole';
import { showPostingListing } from '../../util/postingRead';
import * as log from '../../util/log';

// ================ Action types ================ //

export const FETCH_JOBLISTINGS_REQUEST = 'app/JobPostsPage/FETCH_JOBLISTINGS_REQUEST';
export const FETCH_JOBLISTINGS_SUCCESS = 'app/JobPostsPage/FETCH_JOBLISTINGS_SUCCESS';
export const FETCH_JOBLISTINGS_ERROR = 'app/JobPostsPage/FETCH_JOBLISTINGS_ERROR';

export const FETCH_TRANSACTIONS_REQUEST = 'app/JobPostsPage/FETCH_TRANSACTIONS_REQUEST';
export const FETCH_TRANSACTIONS_SUCCESS = 'app/JobPostsPage/FETCH_TRANSACTIONS_SUCCESS';
export const FETCH_TRANSACTIONS_ERROR = 'app/JobPostsPage/FETCH_TRANSACTIONS_ERROR';

export const INITIATE_MESSAGE_TRANSACTION_REQUEST = 'app/JobPostsPage/INITIATE_MESSAGE_TRANSACTION_REQUEST';
export const INITIATE_MESSAGE_TRANSACTION_SUCCESS = 'app/JobPostsPage/INITIATE_MESSAGE_TRANSACTION_SUCCESS';
export const INITIATE_MESSAGE_TRANSACTION_ERROR = 'app/JobPostsPage/INITIATE_MESSAGE_TRANSACTION_ERROR';

export const REJECT_APPLICATION_REQUEST = 'app/JobPostsPage/REJECT_APPLICATION_REQUEST';
export const REJECT_APPLICATION_SUCCESS = 'app/JobPostsPage/REJECT_APPLICATION_SUCCESS';
export const REJECT_APPLICATION_ERROR = 'app/JobPostsPage/REJECT_APPLICATION_ERROR';

export const SCHEDULE_INTERVIEW_REQUEST = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_REQUEST';
export const SCHEDULE_INTERVIEW_SUCCESS = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_SUCCESS';
export const SCHEDULE_INTERVIEW_ERROR = 'app/RFPPostsPage/SCHEDULE_INTERVIEW_ERROR';

export const UPDATE_SCHEDULED_TX_REQUEST = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_REQUEST';
export const UPDATE_SCHEDULED_TX_SUCCESS = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_SUCCESS';
export const UPDATE_SCHEDULED_TX_ERROR = 'app/RFPPostsPage/UPDATE_SCHEDULED_TX_ERROR';

export const SEND_SCHEDULED_MAIL_REQUEST = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_REQUEST';
export const SEND_SCHEDULED_MAIL_SUCCESS = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_SUCCESS';
export const SEND_SCHEDULED_MAIL_ERROR = 'app/RFPPostsPage/SEND_SCHEDULED_MAIL_ERROR';

export const SHORTLIST_REQUEST = 'app/JobPostsPage/SHORTLIST_REQUEST';
export const SHORTLIST_SUCCESS = 'app/JobPostsPage/SHORTLIST_SUCCESS';
export const SHORTLIST_ERROR = 'app/JobPostsPage/SHORTLIST_ERROR';

export const REVERT_TO_PENDING_REQUEST = 'app/JobPostsPage/REVERT_TO_PENDING_REQUEST';
export const REVERT_TO_PENDING_SUCCESS = 'app/JobPostsPage/REVERT_TO_PENDING_SUCCESS';
export const REVERT_TO_PENDING_ERROR = 'app/JobPostsPage/REVERT_TO_PENDING_ERROR';

export const RUN_INTEGRITY_CHECK_REQUEST = 'app/JobPostsPage/RUN_INTEGRITY_CHECK_REQUEST';
export const RUN_INTEGRITY_CHECK_SUCCESS = 'app/JobPostsPage/RUN_INTEGRITY_CHECK_SUCCESS';
export const RUN_INTEGRITY_CHECK_ERROR = 'app/JobPostsPage/RUN_INTEGRITY_CHECK_ERROR';

export const LOAD_INTEGRITY_CHECK_STATUSES_SUCCESS = 'app/JobPostsPage/LOAD_INTEGRITY_CHECK_STATUSES_SUCCESS';
export const LOAD_INTEGRITY_CHECK_STATUSES_REQUEST = 'app/JobPostsPage/LOAD_INTEGRITY_CHECK_STATUSES_REQUEST';
export const LOAD_INTEGRITY_CHECK_SCOPES_SUCCESS = 'app/JobPostsPage/LOAD_INTEGRITY_CHECK_SCOPES_SUCCESS';

export const LOAD_MATCH_SCORES_REQUEST = 'app/JobPostsPage/LOAD_MATCH_SCORES_REQUEST';
export const LOAD_MATCH_SCORES_SUCCESS = 'app/JobPostsPage/LOAD_MATCH_SCORES_SUCCESS';
export const LOAD_MATCH_SCORES_ERROR = 'app/JobPostsPage/LOAD_MATCH_SCORES_ERROR';

export const LOAD_CANDIDATE_PROFILE_SUMMARIES_REQUEST = 'app/JobPostsPage/LOAD_CANDIDATE_PROFILE_SUMMARIES_REQUEST';
export const LOAD_CANDIDATE_PROFILE_SUMMARIES_SUCCESS = 'app/JobPostsPage/LOAD_CANDIDATE_PROFILE_SUMMARIES_SUCCESS';
export const LOAD_CANDIDATE_PROFILE_SUMMARIES_ERROR = 'app/JobPostsPage/LOAD_CANDIDATE_PROFILE_SUMMARIES_ERROR';

// --- SkillFit Check (mirrors the Integrity Check action types above) ---
export const SEND_SKILLFIT_CHECK_REQUEST = 'app/JobPostsPage/SEND_SKILLFIT_CHECK_REQUEST';
export const SEND_SKILLFIT_CHECK_SUCCESS = 'app/JobPostsPage/SEND_SKILLFIT_CHECK_SUCCESS';
export const SEND_SKILLFIT_CHECK_ERROR = 'app/JobPostsPage/SEND_SKILLFIT_CHECK_ERROR';

export const LOAD_SKILLFIT_STATUSES_SUCCESS = 'app/JobPostsPage/LOAD_SKILLFIT_STATUSES_SUCCESS';
export const LOAD_SKILLFIT_STATUSES_REQUEST = 'app/JobPostsPage/LOAD_SKILLFIT_STATUSES_REQUEST';
// A new, parallel slice for the widened per-candidate SkillFit details (identity-outcome,
// invitation-log fields). Deliberately additive — skillFitStatuses itself (a bare uiStatus string
// map, consumed by several existing string-equality call sites) is untouched.
export const LOAD_SKILLFIT_DETAILS_SUCCESS = 'app/JobPostsPage/LOAD_SKILLFIT_DETAILS_SUCCESS';
// Additive sibling action, dispatched from the same already-fetched
// checkCustomerSkillFitCheckStatus response loadSkillFitStatuses already reads — no extra network
// call.
export const LOAD_ACCOMMODATION_STATUSES_SUCCESS = 'app/JobPostsPage/LOAD_ACCOMMODATION_STATUSES_SUCCESS';
// A new, parallel slice for the dashboard's per-candidate Total Score + proctoring-risk data,
// keyed by transactionId. Additive — skillFitStatuses/skillFitDetails are untouched (never cached
// server-side; refetched fresh at read time).
export const LOAD_SKILLFIT_SCORE_AND_RISK_SUCCESS = 'app/JobPostsPage/LOAD_SKILLFIT_SCORE_AND_RISK_SUCCESS';

export const FETCH_POSTED_BY_OPTIONS_REQUEST = 'app/JobPostsPage/FETCH_POSTED_BY_OPTIONS_REQUEST';
export const FETCH_POSTED_BY_OPTIONS_SUCCESS = 'app/JobPostsPage/FETCH_POSTED_BY_OPTIONS_SUCCESS';
export const FETCH_POSTED_BY_OPTIONS_ERROR = 'app/JobPostsPage/FETCH_POSTED_BY_OPTIONS_ERROR';

export const SET_LOADING_STATE = 'app/JobPostsPage/SET_LOADING_STATE';
export const SET_MESSAGE_TXN_ID = 'app/JobPostsPage/SET_MESSAGE_TXN_ID';

// ================ Helper Functions ================ //




// ================ Reducer ================ //

const initialState = {
  fetchInProgress: false,
  fetchJobListingsError: null,
  fetchTransactionsError: null,
  initiateTransactionError: null,
  rejectApplicationError: null,
  pagination: null,
  jobListings: null,
  listingTransactions: null,
  listingTransactionsPagination: null,
  listingTransactionsSummary: null,
  messageTxnId: null,
  rejectApplicationSuccess: false,
  rejecting: false,
  rejected: false,
  rejectedTxnIds: [],
  scheduledInterviewLinks: null,
  scheduleError: null,
  updateScheduledTxError: null,
  updateScheduledTxSuccess: false,
  updatingScheduledTx: false,
  sendScheduledMailError: null,
  sendScheduledMailSuccess: false,
  sendingScheduledMail: false,
  shortlisting: false,
  shortlistSuccess: false,
  shortlistError: null,
  revertToPendingError: null,
  revertToPendingSuccess: false,
  revertToPending: false,
  integrityCheckInProgress: null,
  integrityCheckError: null,
  integrityCheckResult: null,
  loading: false,
  integrityCheckStatuses: {},
  integrityCheckStatusesLoading: false,
  // Sibling map to integrityCheckStatuses, keyed the same way: { scope, detailsOpen } of the
  // employer's check. The status map keeps its plain strings for the filter and labels.
  integrityCheckScopes: {},
  matchScoresByTxId: {},
  matchScoresLoading: false,
  candidateProfileSummaryByListingId: {},
  candidateProfileSummariesLoading: false,
  skillFitCheckInProgress: null,
  skillFitCheckError: null,
  skillFitCheckResult: null,
  skillFitStatuses: {},
  skillFitStatusesLoading: false,
  skillFitDetails: {},
  // Sibling flat map, same convention as skillFitStatuses/integrityCheckStatuses above —
  // additive, does not restructure either.
  accommodationStatuses: {},
  // Parallel slice, per-transaction { totalScore, hardSubtotal, softSubtotal, perCompetency,
  // isEqualWeighted, riskScore, riskBand } | null. Additive, never restructures the slices above.
  skillFitScoreAndRisk: {},
  postedByOptions: [],
  fetchPostedByOptionsInProgress: false,
  fetchPostedByOptionsError: null,
};


export default function jobsPostsPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {

    case FETCH_JOBLISTINGS_REQUEST:
      return { ...state, fetchInProgress: true, fetchJobListingsError: null };
    case FETCH_JOBLISTINGS_SUCCESS:
      return { ...state, fetchInProgress: false, jobListings: payload }
    case FETCH_JOBLISTINGS_ERROR:
      return { ...state, fetchInProgress: false, fetchJobListingsError: payload };

    case FETCH_TRANSACTIONS_REQUEST:
      return { ...state, fetchInProgress: true, fetchTransactionsError: null };
    case FETCH_TRANSACTIONS_SUCCESS: {
      const hasStructuredPayload = payload && !Array.isArray(payload) && typeof payload === 'object';
      const listingTransactions = hasStructuredPayload ? payload?.transactions || [] : payload;
      const listingTransactionsPagination = hasStructuredPayload ? payload?.pagination || null : null;
      const listingTransactionsSummary = hasStructuredPayload ? payload?.summary || null : null;
      return {
        ...state,
        fetchInProgress: false,
        listingTransactions: listingTransactions,
        listingTransactionsPagination,
        listingTransactionsSummary,
      }
    }
    case FETCH_TRANSACTIONS_ERROR:
      return { ...state, fetchInProgress: false, fetchTransactionsError: payload }

    case INITIATE_MESSAGE_TRANSACTION_REQUEST:
      return { ...state, initiateTransactionError: null };
    case INITIATE_MESSAGE_TRANSACTION_SUCCESS:
      return { ...state, initiateTransactionError: null };
    case INITIATE_MESSAGE_TRANSACTION_ERROR:
      return { ...state, initiateTransactionError: payload };
   
    case SET_MESSAGE_TXN_ID:
      return { ...state, messageTxnId: payload };

    case REJECT_APPLICATION_REQUEST:
      return { ...state, rejected: false, rejectApplicationError: null, rejectApplicationSuccess: false, rejecting: true };
    case REJECT_APPLICATION_SUCCESS:
      return { 
        ...state, 
        rejectApplicationError: null, 
        rejectApplicationSuccess: true, 
        rejecting: false,
        rejected: true,
        rejectedTxnIds: [...state.rejectedTxnIds, payload],
      };
    case REJECT_APPLICATION_ERROR:
      return { ...state, rejected: false, rejectApplicationError: payload, rejectApplicationSuccess: false, rejecting: false };

    case SCHEDULE_INTERVIEW_REQUEST:
      return { ...state, scheduleError: null };
    case SCHEDULE_INTERVIEW_SUCCESS:
      return { ...state, scheduleError: null, scheduledInterviewLinks: payload };
    case SCHEDULE_INTERVIEW_ERROR:
      return { ...state, scheduleError: payload };

    case UPDATE_SCHEDULED_TX_REQUEST:
      return { ...state, updateScheduledTxError: null, updateScheduledTxSuccess: false, updatingScheduledTx: true };
    case UPDATE_SCHEDULED_TX_SUCCESS:
      return { ...state, updateScheduledTxError: null, updateScheduledTxSuccess: true, updatingScheduledTx: false };
    case UPDATE_SCHEDULED_TX_ERROR:
      return { ...state, updateScheduledTxError: payload, updateScheduledTxSuccess: false, updatingScheduledTx: false };

    case SEND_SCHEDULED_MAIL_REQUEST:
      return { ...state, sendScheduledMailError: null, sendScheduledMailSuccess: false, sendingScheduledMail: true };
    case SEND_SCHEDULED_MAIL_SUCCESS:
      return { ...state, sendScheduledMailError: null, sendScheduledMailSuccess: true, sendingScheduledMail: false };
    case SEND_SCHEDULED_MAIL_ERROR:
      return { ...state, sendScheduledMailError: payload, sendScheduledMailSuccess: false, sendingScheduledMail: false };

    case SHORTLIST_REQUEST:
      return { ...state, shortlistError: null, shortlistSuccess: false, shortlisting: true };
    case SHORTLIST_SUCCESS:
      return { ...state, shortlistError: null, shortlistSuccess: true, shortlisting: false };
    case SHORTLIST_ERROR:
      return { ...state, shortlistError: payload, shortlistSuccess: false, shortlisting: false };

    case REVERT_TO_PENDING_REQUEST:
      return { ...state, revertToPendingError: null, revertToPendingSuccess: false, revertToPending: true };
    case REVERT_TO_PENDING_SUCCESS:
      return { ...state, revertToPendingError: null, revertToPendingSuccess: true, revertToPending: false };
    case REVERT_TO_PENDING_ERROR:
      return { ...state, revertToPendingError: payload, revertToPendingSuccess: false, revertToPending: false };

    case RUN_INTEGRITY_CHECK_REQUEST:
      return { ...state, integrityCheckInProgress: payload, integrityCheckError: null, integrityCheckResult: null };
    case RUN_INTEGRITY_CHECK_SUCCESS:
      return { ...state, integrityCheckInProgress: null, integrityCheckError: null, integrityCheckResult: payload };
    case RUN_INTEGRITY_CHECK_ERROR:
      return { ...state, integrityCheckInProgress: null, integrityCheckError: payload, integrityCheckResult: null };

    case LOAD_INTEGRITY_CHECK_STATUSES_REQUEST:
      return { ...state, integrityCheckStatusesLoading: true };
    case LOAD_INTEGRITY_CHECK_STATUSES_SUCCESS:
      return { ...state, integrityCheckStatuses: { ...state.integrityCheckStatuses, ...payload }, integrityCheckStatusesLoading: false };
    case LOAD_INTEGRITY_CHECK_SCOPES_SUCCESS:
      return { ...state, integrityCheckScopes: { ...state.integrityCheckScopes, ...payload } };

    case LOAD_MATCH_SCORES_REQUEST:
      return { ...state, matchScoresLoading: true };
    case LOAD_MATCH_SCORES_SUCCESS:
      return { ...state, matchScoresByTxId: { ...state.matchScoresByTxId, ...payload }, matchScoresLoading: false };
    case LOAD_MATCH_SCORES_ERROR:
      return { ...state, matchScoresLoading: false };

    case LOAD_CANDIDATE_PROFILE_SUMMARIES_REQUEST:
      return { ...state, candidateProfileSummariesLoading: true };
    case LOAD_CANDIDATE_PROFILE_SUMMARIES_SUCCESS:
      return {
        ...state,
        candidateProfileSummaryByListingId: { ...state.candidateProfileSummaryByListingId, ...payload },
        candidateProfileSummariesLoading: false,
      };
    case LOAD_CANDIDATE_PROFILE_SUMMARIES_ERROR:
      return { ...state, candidateProfileSummariesLoading: false };

    case SEND_SKILLFIT_CHECK_REQUEST:
      return { ...state, skillFitCheckInProgress: payload, skillFitCheckError: null, skillFitCheckResult: null };
    case SEND_SKILLFIT_CHECK_SUCCESS:
      return { ...state, skillFitCheckInProgress: null, skillFitCheckError: null, skillFitCheckResult: payload };
    case SEND_SKILLFIT_CHECK_ERROR:
      return { ...state, skillFitCheckInProgress: null, skillFitCheckError: payload, skillFitCheckResult: null };

    case LOAD_SKILLFIT_STATUSES_REQUEST:
      return { ...state, skillFitStatusesLoading: true };
    case LOAD_SKILLFIT_STATUSES_SUCCESS:
      return { ...state, skillFitStatuses: { ...state.skillFitStatuses, ...payload }, skillFitStatusesLoading: false };
    case LOAD_SKILLFIT_DETAILS_SUCCESS:
      return { ...state, skillFitDetails: { ...state.skillFitDetails, ...payload } };

    case LOAD_ACCOMMODATION_STATUSES_SUCCESS:
      return { ...state, accommodationStatuses: { ...state.accommodationStatuses, ...payload } };
    case LOAD_SKILLFIT_SCORE_AND_RISK_SUCCESS:
      return { ...state, skillFitScoreAndRisk: { ...state.skillFitScoreAndRisk, ...payload } };

    case FETCH_POSTED_BY_OPTIONS_REQUEST:
      return { ...state, fetchPostedByOptionsInProgress: true, fetchPostedByOptionsError: null };
    case FETCH_POSTED_BY_OPTIONS_SUCCESS:
      return { ...state, fetchPostedByOptionsInProgress: false, postedByOptions: payload };
    case FETCH_POSTED_BY_OPTIONS_ERROR:
      return { ...state, fetchPostedByOptionsInProgress: false, fetchPostedByOptionsError: payload };

    case SET_LOADING_STATE:
      return { ...state, loading: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchJobListingsRequest = () => ({ type: FETCH_JOBLISTINGS_REQUEST });
const fetchJobListingsSuccess = response => ({
  type: FETCH_JOBLISTINGS_SUCCESS,
  payload: response,
});
const fetchJobListingsError = e => ({
  type: FETCH_JOBLISTINGS_ERROR,
  error: true,
  payload: e,
});

const fetchTransactionsRequest = () => ({ type: FETCH_TRANSACTIONS_REQUEST });
const fetchTransactionsSuccess = response => ({
  type: FETCH_TRANSACTIONS_SUCCESS,
  payload: response,
});
const fetchTransactionsError = e => ({
  type: FETCH_TRANSACTIONS_ERROR,
  error: true,
  payload: e,
});

const initiateMessageTransactionRequest = () => ({ type: INITIATE_MESSAGE_TRANSACTION_REQUEST });
const initiateMessageTransactionSuccess = () => ({ type: INITIATE_MESSAGE_TRANSACTION_SUCCESS });
const initiateMessageTransactionError = e => ({
  type: INITIATE_MESSAGE_TRANSACTION_ERROR,
  error: true,
  payload: e,
});


const rejectApplicationRequest = () => ({ type: REJECT_APPLICATION_REQUEST });
const rejectApplicationSuccess = (txId) => ({ type: REJECT_APPLICATION_SUCCESS, payload: txId });
const rejectApplicationError = e => ({
  type: REJECT_APPLICATION_ERROR,
  error: true,
  payload: e,
});

export const scheduleInterviewRequest = () => ({ type: SCHEDULE_INTERVIEW_REQUEST });
export const scheduleInterviewSuccess = () => ({ type: SCHEDULE_INTERVIEW_SUCCESS });
export const scheduleInterviewError = e => ({
  type: SCHEDULE_INTERVIEW_ERROR,
  error: true,
  payload: e,
});

export const updateScheduledTxRequest = () => ({ type: UPDATE_SCHEDULED_TX_REQUEST });
export const updateScheduledTxSuccess = () => ({ type: UPDATE_SCHEDULED_TX_SUCCESS });
export const updateScheduledTxError = e => ({
  type: UPDATE_SCHEDULED_TX_ERROR,
  error: true,
  payload: e,
});

export const sendScheduledMailRequest = () => ({ type: SEND_SCHEDULED_MAIL_REQUEST });
export const sendScheduledMailSuccess = () => ({ type: SEND_SCHEDULED_MAIL_SUCCESS });
export const sendScheduledMailError = e => ({
  type: SEND_SCHEDULED_MAIL_ERROR,
  error: true,
  payload: e,
});

export const shortListRequest = () => ({ type: SHORTLIST_REQUEST });
export const shortListSuccess = () => ({ type: SHORTLIST_SUCCESS });
export const shortListError = e => ({
  type: SHORTLIST_ERROR,
  error: true,
  payload: e,
});

export const revertToPendingRequest = () => ({ type: REVERT_TO_PENDING_REQUEST });
export const revertToPendingSuccess = () => ({ type: REVERT_TO_PENDING_SUCCESS });
export const revertToPendingError = e => ({
  type: REVERT_TO_PENDING_ERROR,
  error: true,
  payload: e,
});

const runIntegrityCheckRequest = (candidateId) => ({ type: RUN_INTEGRITY_CHECK_REQUEST, payload: candidateId });
const runIntegrityCheckSuccess = (result) => ({ type: RUN_INTEGRITY_CHECK_SUCCESS, payload: result });
const runIntegrityCheckError = e => ({
  type: RUN_INTEGRITY_CHECK_ERROR,
  error: true,
  payload: e,
});

const loadIntegrityCheckStatusesSuccess = (statuses) => ({ type: LOAD_INTEGRITY_CHECK_STATUSES_SUCCESS, payload: statuses });
const loadIntegrityCheckStatusesRequest = () => ({ type: LOAD_INTEGRITY_CHECK_STATUSES_REQUEST });
const loadIntegrityCheckScopesSuccess = scopes => ({ type: LOAD_INTEGRITY_CHECK_SCOPES_SUCCESS, payload: scopes });

// The statuses of a Verified check: plain, with documents expired, and with a re-check requested.
const COMPLETED_STATUSES = ['COMPLETED', 'COMPLETED_LAPSED', 'RECHECK_REQUESTED'];
// Every status the applicants page can show for a check that exists.
const KNOWN_CHECK_STATUSES = [...COMPLETED_STATUSES, 'IN_REVIEW'];

// The scope of the employer's check and whether the candidate's verified details are open to them.
// A server that does not send these reads as it always did: identity + work, open once Verified.
// A Verified check also carries how many of its documents have lapsed and whether asking for a
// re-check would be free, when the server says so.
const integrityScopeEntry = result => {
  if (!result?.hasIntegrityCheck) {
    return { scope: null, detailsOpen: result?.detailsOpen === true };
  }
  return {
    scope: normalizeScope(result.scope),
    // The widest scope already Verified, when the server names it; it can be narrower than
    // `scope` while a wider check is still open.
    ...(result.completedScope !== undefined
      ? { completedScope: result.completedScope == null ? null : normalizeScope(result.completedScope) }
      : {}),
    detailsOpen:
      typeof result.detailsOpen === 'boolean' ? result.detailsOpen : COMPLETED_STATUSES.includes(result.uiStatus),
    ...(result.lapsedCount !== undefined ? { lapsedCount: result.lapsedCount } : {}),
    ...(result.recheckFree !== undefined ? { recheckFree: result.recheckFree } : {}),
  };
};

const loadMatchScoresRequest = () => ({ type: LOAD_MATCH_SCORES_REQUEST });
const loadMatchScoresSuccess = (scores) => ({ type: LOAD_MATCH_SCORES_SUCCESS, payload: scores });
const loadMatchScoresError = e => ({
  type: LOAD_MATCH_SCORES_ERROR,
  error: true,
  payload: e,
});

const loadCandidateProfileSummariesRequest = () => ({ type: LOAD_CANDIDATE_PROFILE_SUMMARIES_REQUEST });
const loadCandidateProfileSummariesSuccess = (summaries) => ({ type: LOAD_CANDIDATE_PROFILE_SUMMARIES_SUCCESS, payload: summaries });
const loadCandidateProfileSummariesError = e => ({
  type: LOAD_CANDIDATE_PROFILE_SUMMARIES_ERROR,
  error: true,
  payload: e,
});

const sendSkillFitCheckRequest = (txId) => ({ type: SEND_SKILLFIT_CHECK_REQUEST, payload: txId });
const sendSkillFitCheckSuccess = (result) => ({ type: SEND_SKILLFIT_CHECK_SUCCESS, payload: result });
const sendSkillFitCheckError = e => ({
  type: SEND_SKILLFIT_CHECK_ERROR,
  error: true,
  payload: e,
});

const loadSkillFitStatusesSuccess = (statuses) => ({ type: LOAD_SKILLFIT_STATUSES_SUCCESS, payload: statuses });
const loadSkillFitStatusesRequest = () => ({ type: LOAD_SKILLFIT_STATUSES_REQUEST });
const loadSkillFitDetailsSuccess = (details) => ({ type: LOAD_SKILLFIT_DETAILS_SUCCESS, payload: details });
const loadAccommodationStatusesSuccess = (statuses) => ({
  type: LOAD_ACCOMMODATION_STATUSES_SUCCESS,
  payload: statuses,
});
const loadSkillFitScoreAndRiskSuccess = (scores) => ({
  type: LOAD_SKILLFIT_SCORE_AND_RISK_SUCCESS,
  payload: scores,
});

const fetchPostedByOptionsRequest = () => ({ type: FETCH_POSTED_BY_OPTIONS_REQUEST });
const fetchPostedByOptionsSuccess = options => ({ type: FETCH_POSTED_BY_OPTIONS_SUCCESS, payload: options });
const fetchPostedByOptionsError = e => ({
  type: FETCH_POSTED_BY_OPTIONS_ERROR,
  error: true,
  payload: e,
});

export const setLoadingState = loading => ({
  type: SET_LOADING_STATE,
  payload: loading,
});

export const setMessageTxnId = messageTxnId => ({
  type: SET_MESSAGE_TXN_ID,
  payload: messageTxnId,
});

export const fetchPostedByOptions = () => async (dispatch, getState) => {
  dispatch(fetchPostedByOptionsRequest());

  const state = getState();
  const { currentUser } = state.user;
  const profileListingId =
    currentUser?.attributes?.profile?.publicData?.firstListingId ||
    currentUser?.attributes?.profile?.publicData?.profileListingId;

  if (!profileListingId) {
    dispatch(fetchPostedByOptionsSuccess([]));
    return [];
  }

  try {
    // Only people who have joined can have posted anything. Pending invitations are held by the
    // server for the company's admin alone, so they are not offered here.
    const addedUsersResponse = await getAddedUsersOfCompany({ profileListingId });

    const addedUsers = denormalisedResponseEntities(addedUsersResponse) || [];
    const addedNames = addedUsers
      .map(user => user?.attributes?.profile?.displayName || user?.attributes?.email)
      .filter(Boolean);

    const options = Array.from(new Set(addedNames));
    dispatch(fetchPostedByOptionsSuccess(options));
    return options;
  } catch (error) {
    dispatch(fetchPostedByOptionsError(error));
    throw error;
  }
};

// ================ Thunks ================ //

const RESULT_PAGE_SIZE = 42;
const MESSAGES_PAGE_SIZE = 100;
const APPLICATIONS_PAGE_SIZE = 9;

const getMainAccountId = async (user, sdk) => {
  if (!user) return null;

  const userType = userTypeOf(user);
  const role = teamRoleOf(user);

  if (userType === 'agency' || userType === 'customer') {
    if (role === 'Admin' && user?.attributes?.profile?.publicData?.firstListingId !== undefined) {
      return user.id?.uuid;
    } else {
      const profileListingId = user.attributes?.profile?.publicData?.profileListingId;

      const listingResponse = await sdk.listings.show({ id: profileListingId });
      const listing = listingResponse?.data?.data;

      return listing?.attributes?.publicData?.adminId;
    }
  }

  return user.id?.uuid;
};

const fetchPersonaRecordsForUser = async (profileListingId) => {
  if (!profileListingId) return [];

  try {
    const apiResponse = await fetchPersonaRecords({ profileListingId });
    return apiResponse?.success && apiResponse?.data ? apiResponse.data : [];
  } catch (error) {
    return [];
  }
};

const normalizeTransactionsResponse = response => {
  if (Array.isArray(response)) {
    return {
      transactions: response,
      pagination: null,
      summary: null,
    };
  }

  return {
    transactions: Array.isArray(response?.transactions) ? response.transactions : [],
    pagination: response?.pagination || null,
    summary: response?.summary || null,
  };
};

const hydrateListingTransactions = async ({ rawTransactions, mergedListings, currentUserAdminId, sdk }) => {
  const listingsMap = new Map((mergedListings || []).map(listing => [listing?.id?.uuid, listing]));
  const normalizeId = value => {
    if (!value) {
      return value;
    }

    if (typeof value === 'object') {
      return value?.uuid || value?.id?.uuid || value?.id || null;
    }

    return value;
  };

  const transactions = (rawTransactions || [])
    .map(tx => ({
      ...tx,
      listingId: normalizeId(tx?.listingId),
      customerId: normalizeId(tx?.customerId),
      providerId: normalizeId(tx?.providerId),
    }))
    .filter(tx => listingsMap.has(tx?.listingId));

  if (!transactions.length) {
    return [];
  }

  const userIds = new Set();
  const agencyListingIds = new Set();

  transactions.forEach(t => {
    if (t?.customerId) userIds.add(t.customerId);
    if (t?.providerId) userIds.add(t.providerId);
  });

  const userDetailsPromises = Array.from(userIds).map(userId =>
    getUserDetails({
      userId,
      responseFields: [
        'email',
        'profile.displayName',
        'profile.publicData.userType',
        'profile.publicData.profileListingId',
        'profile.publicData.firstListingId',
        'profile.publicData.agencyProfile',
        'profile.publicData.onBoardingInfo',
        'profile.publicData.phoneNumber',
        'profile.publicData.tags',
        'profile.publicData.skills',
        'profile.publicData.certificationsAndAwards',
        'profile.publicData.education',
        'profile.publicData.pastExperience',
        'profile.publicData.currentEmployer',
        'profile.metadata.currentEmployerConfirmation',
        'profile.publicData.identityAndWorkAuthorizationDetails',
        'profile.publicData.cityAddress',
        'profile.publicData.stateAddress',
        'profile.publicData.countryAddress',
        'profile.publicData.resumeUrl',
        'profile.publicData.resumeName',
      ],
      imageFields: [
        'variants.square-small',
        'variants.square-small2x',
        'variants.listing-card',
        'variants.listing-card-2x',
      ],
    })
      .then(response => ({
        userId,
        data: response
          ? {
              ...response?.data?.data,
              profileImage: response?.data?.included?.[0],
            }
          : null,
      }))
      .catch(() => ({ userId, data: null }))
  );

  const userDetailsResults = await Promise.all(userDetailsPromises);
  const userDetailsMap = new Map(userDetailsResults.map(({ userId, data }) => [userId, data]));

  userDetailsResults.forEach(({ data }) => {
    if (userTypeOf(data) === 'agency') {
      const profileListingId = data?.attributes?.profile?.publicData?.profileListingId;
      if (profileListingId) agencyListingIds.add(profileListingId);
    }
  });

  // For candidates applied on behalf of by an agency, the tx customer is the
  // candidate (not the agency), so the agency listing isn't picked up above.
  // Pull it in via tx.agencyListingId so we can resolve the "Applied by" name.
  transactions.forEach(t => {
    if (t?.appliedByAgency && t?.agencyListingId) agencyListingIds.add(t.agencyListingId);
  });

  const agencyListingPromises = Array.from(agencyListingIds).map(listingId =>
    sdk.listings
      .show({
        id: listingId,
        include: ['images', 'currentStock'],
        'fields.image': [
          'variants.square-small',
          'variants.square-small2x',
          'variants.square-xsmall',
          'variants.square-xsmall2x',
          'variants.listing-card',
          'variants.listing-card-2x',
        ],
        'limit.images': 1,
      })
      .then(response => ({
        listingId,
        data: {
          ...response?.data?.data,
          images: response?.data?.included,
        },
      }))
      .catch(() => ({ listingId, data: null }))
  );

  const agencyListingResults = await Promise.all(agencyListingPromises);
  const agencyListingsMap = new Map(agencyListingResults.map(({ listingId, data }) => [listingId, data]));

  const allConvs = await conversations({ actionType: 'list', userId: currentUserAdminId }).catch(() => []);
  const convLookup = new Map(
    (allConvs || []).map(conv => {
      const sortedIds = (conv.participantIds || []).slice().sort();
      return [sortedIds.join('|'), conv.conversationId];
    })
  );

  const uniqueMessageKeys = new Set();
  const messageTransactionParams = [];

  transactions.forEach(t => {
    const listing = listingsMap.get(t?.listingId);
    const jobListingAdminId = listing?.attributes?.publicData?.adminId;
    if (!jobListingAdminId) return;
    const userBId = currentUserAdminId !== jobListingAdminId ? currentUserAdminId : jobListingAdminId;
    const key = `${jobListingAdminId}-${userBId}`;
    if (!uniqueMessageKeys.has(key)) {
      uniqueMessageKeys.add(key);
      messageTransactionParams.push({ key, userAId: jobListingAdminId, userBId });
    }
  });

  const messageTransactionsMap = new Map(
    messageTransactionParams.map(({ key, userAId, userBId }) => {
      const lookupKey = [userAId, userBId].sort().join('|');
      return [key, convLookup.get(lookupKey) || null];
    })
  );

  const profileListingIdsForPersona = new Set();
  userDetailsResults.forEach(({ data }) => {
    const profileListingId = data?.attributes?.profile?.publicData?.profileListingId;
    if (profileListingId) {
      profileListingIdsForPersona.add(profileListingId);
    }
  });

  const personaRecordsResults = await Promise.all(
    Array.from(profileListingIdsForPersona).map(profileListingId =>
      fetchPersonaRecordsForUser(profileListingId).then(personaRecords => ({ profileListingId, personaRecords }))
    )
  );

  const personaRecordsMap = new Map(
    personaRecordsResults.map(({ profileListingId, personaRecords }) => [profileListingId, personaRecords])
  );

  const mergedListingTransactions = [];

  transactions.forEach(t => {
    const customer = userDetailsMap.get(t?.customerId);
    const provider = userDetailsMap.get(t?.providerId);
    const listing = listingsMap.get(t?.listingId);

    const fallbackListing = listing || {
      id: { uuid: t?.listingId },
      attributes: {
        title: 'Untitled Job',
        publicData: {
          adminId: currentUserAdminId,
        },
      },
    };

    const jobListingAdminId = fallbackListing?.attributes?.publicData?.adminId;
    const userBId = currentUserAdminId !== jobListingAdminId ? currentUserAdminId : jobListingAdminId;
    const msgTxnKey = `${jobListingAdminId}-${userBId}`;
    const msgTransactionId = messageTransactionsMap.get(msgTxnKey);

    const customerProfileListingId = customer?.attributes?.profile?.publicData?.profileListingId;
    const customerPersonaRecords = personaRecordsMap.get(customerProfileListingId) || [];

    const fallbackCustomer = {
      id: { uuid: t?.customerId },
      attributes: {
        email: '',
        profile: {
          displayName: 'Deleted User',
          publicData: {
            userType: t?.appliedByAgency ? 'agency' : 'candidate',
            personaRecord: [],
            isDeletedUser: true,
          },
        },
      },
    };

    const fallbackProvider = {
      id: { uuid: t?.providerId },
      attributes: {
        email: '',
        profile: {
          displayName: 'Provider',
          publicData: {},
        },
      },
    };

    let finalCustomer = customer || fallbackCustomer;
    if (customer && userTypeOf(customer) === 'agency') {
      const agencyListingId = customer?.attributes?.profile?.publicData?.profileListingId;
      const agencyListing = agencyListingsMap.get(agencyListingId);

      finalCustomer = {
        ...customer,
        attributes: {
          ...customer?.attributes,
          profile: {
            ...customer?.attributes?.profile,
            publicData: {
              ...customer?.attributes?.profile?.publicData,
              ...(agencyListing ? { profileListing: agencyListing } : {}),
              personaRecord: customerPersonaRecords,
            },
          },
        },
      };
    } else {
      finalCustomer = {
        ...(customer || fallbackCustomer),
        attributes: {
          ...(customer?.attributes || fallbackCustomer.attributes),
          profile: {
            ...(customer?.attributes?.profile || fallbackCustomer.attributes.profile),
            publicData: {
              ...(customer?.attributes?.profile?.publicData || fallbackCustomer.attributes.profile.publicData),
              personaRecord: customerPersonaRecords,
            },
          },
        },
      };
    }

    // "Applied by [agency]" name: resolve from the agency profile listing for an
    // on-behalf apply (existing candidate), falling back to the name stored on the
    // tx for a brand-new pending candidate (whose agency listing may not resolve).
    const appliedByAgencyListing = t?.agencyListingId
      ? agencyListingsMap.get(t.agencyListingId)
      : null;
    const appliedByAgencyName = t?.appliedByAgency
      ? appliedByAgencyListing?.attributes?.publicData?.agencyProfile?.name ||
        t?.pendingCandidateAgencyName ||
        ''
      : '';

    mergedListingTransactions.push({
      ...t,
      customer: finalCustomer,
      provider: provider || fallbackProvider,
      listing: fallbackListing,
      msgTransactionId,
      appliedByAgencyName,
    });
  });

  return mergedListingTransactions;
};

const fetchListingTransactionsPageInternal = async ({
  dispatch,
  sdk,
  mergedListings,
  currentUserAdminId,
  page = 1,
  perPage = APPLICATIONS_PAGE_SIZE,
  matchScoreSort = 'none',
}) => {
  try {
    dispatch(fetchTransactionsRequest());

    if (!(mergedListings || []).length) {
      const emptyPagination = {
        currentPage: page,
        perPage,
        totalItems: 0,
        totalPages: 1,
        hasPrevPage: false,
        hasNextPage: false,
      };
      dispatch(
        fetchTransactionsSuccess({
          transactions: [],
          pagination: emptyPagination,
          summary: { totalItems: 0, thisWeekCount: 0 },
        })
      );
      return [];
    }

    // matchScoreSort 'none' reproduces today's exact hardcoded sortBy/sortOrder (a hard regression
    // constraint); 'highest'/'lowest' route into the backend's bounded match-score sort path
    // instead.
    const sortBy = matchScoreSort === 'none' ? 'createdAt' : 'matchScore';
    const sortOrder = matchScoreSort === 'lowest' ? 'asc' : 'desc';

    const rawTransactionResponse = await manualTransactions({
      providerId: currentUserAdminId,
      txType: 'apply',
      type: 'fetch',
      page,
      perPage,
      sortBy,
      sortOrder,
      includePagination: true,
      includeSummary: true,
      includePendingCandidateData: true,
    });

    const { transactions, pagination, summary } = normalizeTransactionsResponse(rawTransactionResponse);
    const hydratedTransactions = await hydrateListingTransactions({
      rawTransactions: transactions,
      mergedListings,
      currentUserAdminId,
      sdk,
    });

    const effectivePagination = pagination || {
      currentPage: page,
      perPage,
      totalItems: hydratedTransactions.length,
      totalPages: 1,
      hasPrevPage: false,
      hasNextPage: false,
    };

    const effectiveSummary = summary || {
      totalItems: effectivePagination.totalItems,
      thisWeekCount: 0,
    };

    dispatch(
      fetchTransactionsSuccess({
        transactions: hydratedTransactions,
        pagination: effectivePagination,
        summary: effectiveSummary,
      })
    );

    return hydratedTransactions;
  } catch (error) {
    dispatch(fetchTransactionsError(storableError(error)));
    return null;
  }
};

export const fetchListingTransactionsPage = (
  page = 1,
  perPage = APPLICATIONS_PAGE_SIZE,
  matchScoreSort = 'none'
) => async (dispatch, getState, sdk) => {
  const state = getState();
  const { currentUser } = state.user;
  const { jobListings } = state.JobPostsPage;

  if (!currentUser || !Array.isArray(jobListings)) {
    return null;
  }

  const currentUserAdminId = await getMainAccountId(currentUser, sdk);
  if (!currentUserAdminId) {
    return null;
  }

  return fetchListingTransactionsPageInternal({
    dispatch,
    sdk,
    mergedListings: jobListings,
    currentUserAdminId,
    page,
    perPage,
    matchScoreSort,
  });
};

export const loadData = (params, search, config) => async (dispatch, getState, sdk) => {
  const { currentUser } = getState().user;

  if (!currentUser) return null;

  dispatch(setLoadingState(true));

  // Any failure ends the load here, so the page leaves its placeholders and can offer a retry.
  try {
    return await loadJobPostsPageData(currentUser, search, config, dispatch, sdk);
  } catch (err) {
    log.error(err, 'job-posts-load-failed');
    dispatch(fetchJobListingsError(storableError(err)));
    dispatch(setLoadingState(false));
    return null;
  }
};

// The company owner, their job listings and the first page of applications. Throws on failure.
const loadJobPostsPageData = async (currentUser, search, config, dispatch, sdk) => {
  const mainUserId = await getMainAccountId(currentUser, sdk);

  let queryParams = parse(search);
  const page = parseInt(queryParams.page, 10) || 1;

  dispatch(fetchJobListingsRequest());

  const {
    aspectWidth = 1,
    aspectHeight = 1,
    variantPrefix = 'listing-card',
  } = config.layout.listingImage;
  const aspectRatio = aspectHeight / aspectWidth;

  queryParams = {
    ...queryParams,
    page,
    perPage: RESULT_PAGE_SIZE,
    include: ['images', 'currentStock'],
    authorId: mainUserId,
    pub_listingType: 'job_listing',
    'fields.image': [`variants.${variantPrefix}`, `variants.${variantPrefix}-2x`],
    ...createImageVariantConfig(`${variantPrefix}`, 400, aspectRatio),
    ...createImageVariantConfig(`${variantPrefix}-2x`, 800, aspectRatio),
    'limit.images': 1,
  };

  let apiQueryParams = queryParams;

  const currentUserAdminId = mainUserId;

  return getOwnJobRfpListings({apiQueryParams, responseFields: ['title', 'description', 'state', 'createdAt', 'publicData', 'privateData']})
    .then(async response => {
      const listingPages = Array.isArray(response?.allListings) ? response.allListings : [];

      const includedMap = listingPages
        .flatMap(pageEntry => pageEntry?.included || [])
        .reduce((map, item) => {
        map[item.id.uuid] = item;
        return map;
      }, {});

      const mergedListings = listingPages
        .flatMap(pageEntry => pageEntry?.data || [])
        .map(listing => {
        let merged = { ...listing };

        if (listing.relationships) {
          Object.keys(listing.relationships).forEach(relKey => {
            const relData = listing.relationships[relKey]?.data;

            if (Array.isArray(relData)) {
              merged[relKey] = relData.map(r => includedMap[r.id.uuid] || r);
            } else if (relData?.id?.uuid) {
              merged[relKey] = includedMap[relData.id.uuid] || relData;
            }
          });
        }

        return merged;
      });

      await fetchListingTransactionsPageInternal({
        dispatch,
        sdk,
        mergedListings,
        currentUserAdminId,
        page: 1,
        perPage: APPLICATIONS_PAGE_SIZE,
      });

      dispatch(fetchJobListingsSuccess(mergedListings));

      dispatch(setLoadingState(false));

      return mergedListings;
    });
};


export const getTransactionsBetweenUsers = (userId1, listingId) => async (dispatch, getState, sdk) => {
  if (!userId1 || !listingId) return null;

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;

  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;

  try {
    let recipientListing = await sdk.listings.show({ id: listingId });
    recipientListing = recipientListing?.data?.data;
    const receiverAdminId = recipientListing?.attributes?.publicData?.adminId;
    if (!receiverAdminId) return null;

    const conv = await conversations({ actionType: 'get', senderId: mainUserId, receiverId: receiverAdminId });

    dispatch(setMessageTxnId(conv?.conversationId || null));
    return conv?.conversationId || null;
  } catch (error) {
    return null;
  }
};

export const initiateTransactionForMessage = (userId, listingId, message, config) => async (dispatch, getState, sdk) => {
  if (!userId || !listingId) return null;
  dispatch(initiateMessageTransactionRequest());

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;
  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;
  
  let userProfileListing = await sdk.listings.show({ id: listingId });
  userProfileListing = userProfileListing?.data?.data;
  const userProfileListingAdminId = userProfileListing?.attributes?.publicData?.adminId;

  try {
    const conv = await conversations({ actionType: 'getOrCreate', senderId: mainUserId, receiverId: userProfileListingAdminId });
    const conversationId = conv?.conversationId;

    await chatMessages({
      actionType: 'send',
      conversationId,
      senderId: mainUserId,
      receiverId: userProfileListingAdminId,
      text: message,
      attachments: [],
    });

    dispatch(initiateMessageTransactionSuccess());
    return conversationId;
  } catch (err) {
    dispatch(initiateMessageTransactionError(storableError(err)));
    return false;
  }

};

export const sendInvitationToUser = (listingId, listingName, toEmail, toUserId, invitedUserName, toUserType, toUserProfileListingId, isJobPosting, isRFPPosting) => async (dispatch, getState, sdk) => {
  
  if (!toUserId || !listingId) return null;

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;

  const mainUserId = await getMainAccountId(currentUser, sdk);
  if (!mainUserId) return null;

  let mainUser = null;

  if(currentUser?.id?.uuid === mainUserId) {
    mainUser = currentUser;
  } else {
    try {
      const mainUserResponse = await sdk.users.show({ id: mainUserId });
      mainUser = mainUserResponse?.data?.data;
    } catch(error) {
      mainUser = currentUser;
    }
  }

  const mainUserName = mainUser?.attributes?.profile?.displayName || currentUser?.attributes?.profile?.displayName || "";
  
  const adminName = mainUserName || "Admin";
  let orgName = "";
  
  try {
    let mainListing = await sdk.listings.show({ id: currentUser?.attributes?.profile?.publicData?.profileListingId || currentUser?.attributes?.profile?.publicData?.firstListingId });
    
    mainListing = mainListing?.data?.data;
    orgName = mainUser?.attributes?.profile?.publicData?.customerProfile?.name || "";

  } catch(error) {
    return;
  }

  return sendPostingInvitation({ listingId, listingName, adminName, orgName, toUserId, invitedRole: toUserType, isJobPosting: isJobPosting, isRFPPosting: isRFPPosting, invitedUserName, res: null })
    .then(async () => {
      // The server has already added the invitee to the posting's invite list.
      try {
        await manualTransactions({ listingId: listingId, txType: 'invitation', invitationType: 'job/rfp', type: 'create', customerId: toUserId, providerId: mainUserId, userAId: mainUserId, userBId: toUserId, metadata: {} });
      } catch (error) {
        // Non-critical: the invitation was sent; only its conversation record failed
      }
      
      return true;
    })
    .catch(() => false);

};

export const rejectApplication = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(rejectApplicationRequest());

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'rejected',
  };

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(rejectApplicationSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.rejected || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, rejectApplications: true, rejected: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(rejectApplicationError(storableError(e)));
      return false;
    });
  
};

export const scheduleInterview = (txId, startTime, userMail, description, summary) => async (dispatch, getState, sdk) => {
  if (!txId) return null;
  dispatch(scheduleInterviewRequest());

  let meetingDetails = {
    // startTime: '2025-09-30T14:30:00+05:30',
    startTime: startTime,
    summary: summary,
    description: description,
    attendees: [`${userMail}`],
  };

  try {
    window.location.href = `http://localhost:4000/api/auth/googleMeet?` + new URLSearchParams({
      ...meetingDetails,
      attendees: JSON.stringify(meetingDetails.attendees),
    });
  } catch (error) {
    dispatch(scheduleInterviewError(storableError(error)));
  }
};

export const updateScheduledTx = (txId, scheduleDate, meetLink, eventId, meetingHeading, meetingDescription) => async (dispatch, getState, sdk) => {
  if (!txId) return null;
  dispatch(updateScheduledTxRequest());

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions({
      transactionId: txId,
      type: 'update',
      status: 'scheduled',
      scheduleDate: scheduleDate,
      meetLink: meetLink,
      eventId: eventId,
      meetingHeading: meetingHeading,
      meetingDescription: meetingDescription,
    })
    .then(async () => {
      dispatch(updateScheduledTxSuccess());

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.scheduled || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, scheduleApplications: true, scheduled: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(updateScheduledTxError(storableError(e)));
      return false;
    });
    
};

// The server addresses the mail from the application itself, so only its id is sent; the address
// parameters stay in the signature for existing call sites and are not sent.
export const sendScheduledMail = (userMail, userName, meetingLink, listingName, meetingDate, meetingTime, schedulerMail, meetingScheduledWithMail, isCandidate, transactionId) => async (dispatch, getState, sdk) => {
  if (!transactionId) return null;
  dispatch(sendScheduledMailRequest());

  const state = getState();
  const { currentUser } = state.user;
  if (!currentUser) return null;

  return sendMeetingScheduledMail({ transactionId, userName, meetingLink, meetingDate, meetingTime, isCandidate })
    .then(() => {
      dispatch(sendScheduledMailSuccess());
      return true;
    })
    .catch(e => {
      dispatch(sendScheduledMailError(storableError(e)));
      return false;
    });
};

export const shortListApplication = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(shortListRequest());

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'shortlisted',
  };

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(shortListSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.shortlisted || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, shortlistApplications: true, shortlisted: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(shortListError(storableError(e)));
      return false;
    });
};

export const revertToPending = (txId) => async (dispatch, getState, sdk) => {
  
  if (!txId) return null;
  dispatch(revertToPendingRequest());

  let toSendPayload = {
    transactionId: txId,
    type: 'update',
    status: 'pending',
  };

  const state = getState();
  const { currentUser } = state.user;
  const txn = await manualTransactions({ transactionId: txId, type: 'fetch' });
  const txnListingId = txn[0]?.listingId;

  const mainAccountId = await getMainAccountId(currentUser, sdk);
  if (!mainAccountId) return null;
  let applierId = mainAccountId === txn[0]?.providerId ? txn[0]?.customerId : txn[0]?.providerId;

  return manualTransactions(toSendPayload)
    .then(async () => {
      dispatch(revertToPendingSuccess(txId));

      try {
        let txnListing = await showPostingListing(sdk, { id: txnListingId });
        txnListing = txnListing?.data?.data;

        let allAppliers = txnListing?.attributes?.publicData?.shortlisted || [];
        // const applierListingId = currentUser?.attributes?.profile?.publicData?.firstListingId || currentUser?.attributes?.profile?.publicData?.profileListingId;
        allAppliers = [...(allAppliers || []), applierId];
        
        await createNewListing({ jobListingId: txnListingId, shortlistApplications: true, shortlisted: allAppliers});

      } catch (err) {
        // Non-critical: primary action succeeded, listing metadata update failed
      }

      return true;
    })
    .catch(e => {
      dispatch(revertToPendingError(storableError(e)));
      return false;
    });
};

export const runIntegrityCheck = (candidateId, listingId, txId, scope) => async (dispatch) => {
  if (!candidateId) return null;
  dispatch(runIntegrityCheckRequest(txId));

  // With no scope chosen the key is left out, and the server reads identity + work.
  const scopeMaybe = scope ? { scope } : {};
  return trackIntegrityCheck({ candidateId, listingId, ...scopeMaybe })
    .then(response => {
      dispatch(runIntegrityCheckSuccess(response));
      if (response?.uiStatus && txId) {
        dispatch(loadIntegrityCheckStatusesSuccess({ [txId]: response.uiStatus }));
      }
      return response;
    })
    .catch(e => {
      dispatch(runIntegrityCheckError(storableError(e)));
      if (e.code === 'INSUFFICIENT_INTEGRITY_CHECK_CREDITS') {
        return { insufficientCredits: true };
      }
      return false;
    });
};

// Asks for a re-check of the employer's Verified check on a candidate whose documents have lapsed.
// `documents` names the ones the employer ticked; the server still decides what has lapsed and
// what it costs, and asks only for named documents it judges lapsed. Answers
// `{ ok: true, uiStatus, creditDeducted }`, or `{ ok: false, code }` with the refusal's code.
export const requestIntegrityRecheck = (candidateId, listingId, txId, documents) => async (dispatch, getState) => {
  try {
    const documentsMaybe = Array.isArray(documents) ? { documents } : {};
    const response = await requestIntegrityCheckRecheck({ candidateId, listingId, ...documentsMaybe });
    const uiStatus = response?.uiStatus || 'RECHECK_REQUESTED';
    if (txId) {
      const before = getState?.()?.JobPostsPage?.integrityCheckScopes?.[txId];
      // The check stays Verified, so its scope and open details are kept.
      dispatch(
        loadIntegrityCheckScopesSuccess({
          [txId]: {
            ...(before || {}),
            ...(response?.scope ? { scope: normalizeScope(response.scope) } : {}),
            ...(response?.lapsedCount !== undefined ? { lapsedCount: response.lapsedCount } : {}),
            recheckFree: null,
          },
        })
      );
      dispatch(loadIntegrityCheckStatusesSuccess({ [txId]: uiStatus }));
    }
    return { ok: true, uiStatus, creditDeducted: response?.creditDeducted === true };
  } catch (e) {
    return { ok: false, code: e?.code || 'RECHECK_FAILED' };
  }
};

export const loadIntegrityCheckStatuses = (transactions) => async (dispatch) => {
  if (!transactions || transactions.length === 0) return;

  // Shortlisted and pending transactions can both have an existing integrity entry.
  const shortlisted = transactions.filter(tx => tx?.status === 'shortlisted' || tx?.status === 'pending' );
  if (shortlisted.length === 0) return;

  dispatch(loadIntegrityCheckStatusesRequest());

  const statusResults = {};
  const scopeResults = {};
  const statusByCandidateListingId = {};
  await Promise.all(
    shortlisted.map(async tx => {
      const candidateListingId =
        tx?.customer?.attributes?.profile?.publicData?.firstListingId ||
        tx?.customer?.attributes?.profile?.publicData?.profileListingId;
      if (!candidateListingId) return;
      try {
        let result = statusByCandidateListingId[candidateListingId];
        if (!result) {
          result = await checkCustomerIntegrityCheckStatus(candidateListingId);
          statusByCandidateListingId[candidateListingId] = result;
        }
        scopeResults[tx.transactionId] = integrityScopeEntry(result);
        if (result?.hasIntegrityCheck) {
          // If any DB entry exists, hide the run button: keep every state the page can show, and
          // map any other state to IN_PROGRESS.
          const uiStatus = result?.uiStatus;
          statusResults[tx.transactionId] = KNOWN_CHECK_STATUSES.includes(uiStatus) ? uiStatus : 'IN_PROGRESS';
        } else {
          statusResults[tx.transactionId] = 'NOT_STARTED';
        }
      } catch (e) {
        statusResults[tx.transactionId] = 'NOT_STARTED';
      }
    })
  );
  dispatch(loadIntegrityCheckScopesSuccess(scopeResults));
  dispatch(loadIntegrityCheckStatusesSuccess(statusResults));
};

// Fetches the fused match score for each given transaction (Promise.all, same shape as
// loadIntegrityCheckStatuses above) - but deliberately NOT called for the full listingTransactions
// list the way that thunk is. getJobApplicationMatchScore is expensive on a cache miss (external
// matcher HTTP call + embedding/vector-search chain), unlike the cheap DB status read
// checkCustomerIntegrityCheckStatus makes, so callers must scope `transactions` to whatever's
// actually visible (the current paginated page), not the full unfiltered list.
export const loadMatchScores = (transactions) => async (dispatch) => {
  if (!transactions || transactions.length === 0) return;

  dispatch(loadMatchScoresRequest());

  const scoreResults = {};
  await Promise.all(
    transactions.map(async tx => {
      const transactionId = tx?.transactionId;
      const listingId = tx?.listing?.id?.uuid || tx?.listingId;
      if (!transactionId || !listingId) return;
      try {
        const result = await getJobApplicationMatchScore({ transactionId, listingId });
        scoreResults[transactionId] = result;
      } catch (e) {
        // Transient failure - leave this transaction's entry absent so the UI keeps showing
        // whatever state it already had (or the pending indicator), rather than surfacing an error.
      }
    })
  );
  dispatch(loadMatchScoresSuccess(scoreResults));
};

// Fetches each candidate's actual profile-listing bio (not the possibly-out-of-sync user-entity
// copy `getUserDetails` returns) so the applicant card's Profile Summary matches what the
// candidate sees on their own profile page. Same shape as
// loadMatchScores above: scoped to the given (current-page) transactions only, per-item fetch
// failures are isolated rather than aborting the whole batch.
export const loadCandidateProfileSummaries = (transactions) => async (dispatch, getState, sdk) => {
  if (!transactions || transactions.length === 0) return;

  dispatch(loadCandidateProfileSummariesRequest());

  const summaryResults = {};
  await Promise.all(
    transactions.map(async tx => {
      const candidatePublicData = tx?.customer?.attributes?.profile?.publicData;
      const listingId = candidatePublicData?.profileListingId || candidatePublicData?.firstListingId;
      if (!listingId) return;
      try {
        const listingResponse = await sdk.listings.show({ id: listingId });
        const bio = listingResponse?.data?.data?.attributes?.publicData?.bio;
        if (bio) {
          summaryResults[listingId] = bio;
        }
      } catch (e) {
        // Transient failure - leave this listing's entry absent so the render falls back to
        // onBoardingInfo.profileSummary / 'No profile summary provided', same as today.
      }
    })
  );
  dispatch(loadCandidateProfileSummariesSuccess(summaryResults));
};

// --- SkillFit Check thunks (mirror the Integrity Check thunks above) ---

// The send answers this when the marketplace could not be reached; nothing was sent and no credit
// was used, so the page can say so rather than show the generic failure.
const SKILLFIT_MARKETPLACE_UNAVAILABLE_CODE = 'SKILLFIT_MARKETPLACE_UNAVAILABLE';

// Sends the server refused on purpose: the candidate already has an invitation waiting for this job,
// or the recruiter is over a sending limit. Nothing was sent and no credit was used; the code is
// passed through so the page can say which one it was.
export const SKILLFIT_SEND_REFUSAL_CODES = [
  'SKILLFIT_CHECK_ALREADY_PENDING',
  'SKILLFIT_SEND_RATE_LIMITED',
  'SKILLFIT_SEND_DAILY_LIMIT_REACHED',
  'SKILLFIT_RESEND_LIMIT_REACHED',
];

export const sendSkillFitCheck = (candidateId, listingId, txId, payload = {}) => async (dispatch) => {
  if (!candidateId) return null;
  dispatch(sendSkillFitCheckRequest(txId));

  return sendSkillFitInvitation({ candidateId, listingId, ...payload })
    .then(response => {
      dispatch(sendSkillFitCheckSuccess(response));
      const uiStatus = response?.uiStatus || 'PENDING';
      if (txId) {
        dispatch(loadSkillFitStatusesSuccess({ [txId]: uiStatus }));
      }
      return response;
    })
    .catch(e => {
      dispatch(sendSkillFitCheckError(storableError(e)));
      if (e.code === 'INSUFFICIENT_SKILLFIT_CHECK_CREDITS') {
        return { insufficientCredits: true };
      }
      if (e.code === SKILLFIT_MARKETPLACE_UNAVAILABLE_CODE) {
        return { marketplaceUnavailable: true };
      }
      if (SKILLFIT_SEND_REFUSAL_CODES.includes(e.code)) {
        return { refusal: e.code };
      }
      return false;
    });
};

// The payload defaults so the older three-arg call shape keeps working, and is spread exactly as
// sendSkillFitCheck spreads it — one buildPayload() feeds both thunks.
export const resendSkillFitCheck = (candidateId, listingId, txId, payload = {}) => async (dispatch) => {
  if (!candidateId) return null;
  dispatch(sendSkillFitCheckRequest(txId));

  return resendSkillFitInvitation({ candidateId, listingId, ...payload })
    .then(response => {
      dispatch(sendSkillFitCheckSuccess(response));
      if (txId) {
        dispatch(loadSkillFitStatusesSuccess({ [txId]: response?.uiStatus || 'PENDING' }));
      }
      return response;
    })
    .catch(e => {
      dispatch(sendSkillFitCheckError(storableError(e)));
      if (e?.code === SKILLFIT_MARKETPLACE_UNAVAILABLE_CODE) {
        return { marketplaceUnavailable: true };
      }
      if (SKILLFIT_SEND_REFUSAL_CODES.includes(e?.code)) {
        return { refusal: e.code };
      }
      // A refusal about the proctor is named, so the page can say what to do about it rather than
      // show the generic failure.
      if (typeof e?.code === 'string' && e.code.startsWith('SKILLFIT_PROCTOR_')) {
        return { proctorRefusal: e.code };
      }
      return false;
    });
};

export const loadSkillFitStatuses = (transactions) => async (dispatch) => {
  if (!transactions || transactions.length === 0) return;

  // Shortlisted and pending transactions can both carry an existing SkillFit entry.
  const relevant = transactions.filter(tx => tx?.status === 'shortlisted' || tx?.status === 'pending');
  if (relevant.length === 0) return;

  dispatch(loadSkillFitStatusesRequest());

  const statusResults = {};
  // A new, parallel results map for the widened per-candidate details — skillFitStatuses itself
  // stays a bare uiStatus string, untouched.
  const detailsResults = {};
  // Additive — captured from the same already-fetched response below, no extra network call.
  const accommodationResults = {};
  // Keyed by candidate AND job, never candidate alone. The same candidate can appear in
  // this batch under two jobs (the job filter is optional, so the list spans every job), and each
  // of those rows holds its own check — collapsing them onto one response is the defect itself.
  const statusByCandidateAndJob = {};
  await Promise.all(
    relevant.map(async tx => {
      const candidateListingId =
        tx?.customer?.attributes?.profile?.publicData?.firstListingId ||
        tx?.customer?.attributes?.profile?.publicData?.profileListingId;
      if (!candidateListingId) return;
      // The job this row is rendered under. Null for a transaction with no listing — the status
      // then resolves candidate-only, the behaviour before per-job scoping was added.
      const jobListingId = tx?.listing?.id?.uuid || null;
      try {
        // The in-flight PROMISE is cached, not its resolved value: these run under Promise.all,
        // so every branch races past a value-cache while the first request is still open and the
        // de-duplication never fires. Two rows on the same job now share one request.
        const cacheKey = `${candidateListingId}::${jobListingId || ''}`;
        if (!statusByCandidateAndJob[cacheKey]) {
          statusByCandidateAndJob[cacheKey] = checkCustomerSkillFitCheckStatus(
            candidateListingId,
            jobListingId
          );
        }
        const result = await statusByCandidateAndJob[cacheKey];
        // uiStatus is one of NOT_STARTED / PENDING / COMPLETED / FAILED (persisted server-side).
        statusResults[tx.transactionId] = result?.hasSkillFitCheck
          ? result?.uiStatus || 'PENDING'
          : 'NOT_STARTED';
        detailsResults[tx.transactionId] = {
          identityVerificationOutcome: result?.identityVerificationOutcome || 'not_applicable',
          jobListingId: result?.jobListingId || null,
          senderUserId: result?.senderUserId || null,
          aiInterviewId: result?.aiInterviewId || null,
          // Additive: the level this entry was invited at, and which derivation produced it — the
          // resend menu renders its level field locked from these.
          storedExperienceLevel: result?.employerVerifiedExperienceLevel ?? null,
          storedExperienceLevelDerivation:
            result?.employerVerifiedExperienceLevelDerivation ?? null,
        };
        accommodationResults[tx.transactionId] = {
          accommodationStatus: result?.accommodationStatus ?? null,
          resolvedPathType: result?.resolvedPathType,
          pendingAccommodationRequestId: result?.pendingAccommodationRequestId,
        };
      } catch (e) {
        statusResults[tx.transactionId] = 'NOT_STARTED';
        accommodationResults[tx.transactionId] = { accommodationStatus: null };
      }
    })
  );
  dispatch(loadSkillFitStatusesSuccess(statusResults));
  dispatch(loadSkillFitDetailsSuccess(detailsResults));
  dispatch(loadAccommodationStatusesSuccess(accommodationResults));
};

// Fetch per-candidate Total Score + proctoring-risk for the dashboard's two independent axes.
// Parallels loadSkillFitStatuses (does NOT modify it): batches one org-scoped call for the given
// job listing over the COMPLETED candidates, storing the response keyed by transactionId. Never
// caches server-side — this refetches fresh whenever called, so the numbers are always current.
export const loadSkillFitScoreAndRisk = (transactions, listingId) => async (dispatch, getState) => {
  if (!listingId || !transactions || transactions.length === 0) return;

  const { skillFitStatuses = {} } = getState().JobPostsPage || {};
  // Only completed checks have a Total Score to compute; map each to its candidateListingId.
  const byCandidateListingId = {};
  transactions.forEach(tx => {
    if (skillFitStatuses[tx.transactionId] !== 'COMPLETED') return;
    const candidateListingId =
      tx?.customer?.attributes?.profile?.publicData?.firstListingId ||
      tx?.customer?.attributes?.profile?.publicData?.profileListingId;
    if (candidateListingId) byCandidateListingId[candidateListingId] = tx.transactionId;
  });

  const candidateListingIds = Object.keys(byCandidateListingId);
  if (candidateListingIds.length === 0) return;

  try {
    const response = await skillFitScoreAndRiskForDashboard({ listingId, candidateListingIds });
    const scores = (response && response.scores) || {};
    const byTransactionId = {};
    Object.entries(byCandidateListingId).forEach(([candidateListingId, txId]) => {
      byTransactionId[txId] = scores[candidateListingId] || null;
    });
    dispatch(loadSkillFitScoreAndRiskSuccess(byTransactionId));
  } catch (e) {
    // Non-fatal: leave the slice as-is (dashboard treats missing entries as "no computed score").
  }
};
